<div class="video-container">
  @if (titre) {
    <h3>{{ titre }}</h3>
  }
  <div class="video-wrapper">
    @if (vimeoUrl) {
      <iframe [src]="vimeoUrl" frameborder="0" allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen class="vimeo-iframe">
      </iframe>
    }
  </div>
</div>